<template>
  <div>
    <div>
      <action-button
        :dark="!buttonSelectedTopLevel"
        @click.native="setButtonTopLevel"
        color="success"
        label="Show Top Level Events for each target"
      />
      <action-button
        :dark="!buttonSelectedAllEvents"
        @click.native="setButtonAllEvents"
        label="Show All Events"
        color="primary"
      />
      <action-button
        :dark="!buttonSelectedOneTarget"
        :disabled="!hasSelectedTarget"
        @click.native="setButtonOneTarget"
        label="Show Events of a Target"
        color="primary"
      />
      <input v-model="selectedTarget"/>
      <datepicker
        lang="eng"
        :value="selectedDate"
        :not-after="todaysDate"
        :clear="e => changeTo(null)"
        input-class="mx-input date-from-to__datepicker-input"/>
    </div>
    <template v-for="eventSpace in eventTypes">
      <div
        v-if="events[eventSpace.event] && events[eventSpace.event].length > 0"
        :key="eventSpace.event" style="width: 1010px; height: 300px;">
        <h1>{{eventSpace.name}}</h1>
        <ag-grid-vue
          style="width: 1010px; height: 200px;"
          :rowData="events[eventSpace.event]"
          class="ag-theme-balham"
          :columnDefs="columnDef">
        </ag-grid-vue>
      </div>
    </template>
  </div>
</template>

<script>
import XandrAPI from '@/api/XandrAPI'
import 'ag-grid-enterprise'
import {AgGridVue} from 'ag-grid-vue'
import Datepicker from 'vue2-datepicker'
import {getLocalDateStringFormatted} from '@/common/U_D.js'
import ActionButton from '@/components/common/actionButton/ActionButton'
import moment from 'moment'

/**
 * have a list for each one....
 * there is also the rule of heirarchies in the timeline of the data as well.
 */

const CE = function (event, name) {
  return {event, name}
}

const STATUS = {
  XANDR_SEGMENTATION_CAMPAIGN_CREATE: 1,
  RECEIVE_TARGET_LIST_FILE: 4,
  XANDR_DATA_CREATE_CAMPAIGN: 7,
  RECEIVE_PLANNING_FILE: 9,
  RECEIVE_XANDR_DATA_UPDATE: 13,
  MAKE_XANDR_DATA_UPDATE: 16,
  CAE_CCPID: 20
}

const COLUMN_DEF = [
  {headerName: 'Days Since Event', width: 150, field: 'daysSinceEvent', sortable: true},
  {headerName: 'CAE ID', width: 90, field: 'data.target.cae_id', sortable: true},
  {headerName: 'Target ID', width: 300, field: 'data.target.id'},
  {headerName: 'Date', width: 200, valueGetter: (params) => { return moment(params.data.date).format('MM/DD/YYYY hh:mm:ss a') }, sortable: true}
]

/**
 * I have the full list of events
 * 1. What I want is the option to find the traces of a particular caeId
 * 2. the option to narrow down the events to the latest event recieved for a caeId.
 *    a. this has a heirarchy to it.
 *    b. there are some that are going to be mixed
 *
 * Heirarchy
 * XANDR_SEGMENTATION_CAMPAIGN_CREATE
 *                                          RECEIVE_XANDR_DATA_UPDATE
 *                                          MAKE_XANDR_DATA_UPDATE
 * RECEIVE_TARGET_LIST_FILE
 * XANDR_DATA_CREATE_CAMPAIGN
 *                                          RECEIVE_XANDR_DATA_UPDATE
 *                                          MAKE_XANDR_DATA_UPDATE
 * RECEIVE_PLANNING_FILE
 *                                          RECEIVE_XANDR_DATA_UPDATE
 *                                          MAKE_XANDR_DATA_UPDATE
 * CAE_CCPID
 *
 * so what I need to do is show the highest ordered events for each target
 * for each target, give me the highest ordered events.
 * so that I have id ---> event
 */

const HEIRARCHY_EVENTS = new Set([
  STATUS.XANDR_SEGMENTATION_CAMPAIGN_CREATE,
  STATUS.RECEIVE_TARGET_LIST_FILE,
  STATUS.XANDR_DATA_CREATE_CAMPAIGN,
  STATUS.RECEIVE_PLANNING_FILE,
  STATUS.CAE_CCPID
])

const SPARCE_EVENTS = [
  [
    STATUS.RECEIVE_XANDR_DATA_UPDATE,
    STATUS.MAKE_XANDR_DATA_UPDATE,
  ],
  [
    STATUS.MAKE_XANDR_DATA_UPDATE
  ]
]

const BUTTON_STATUS = {
  TOP_LEVEL: 1,
  ALL_EVENTS: 2,
  ONE_TARGET: 3
}

export default {
  components: {
    AgGridVue,
    ActionButton,
    Datepicker
  },
  data: () => {
    const EVENTS = {
      XANDR_SEGMENTATION_CAMPAIGN_CREATE: CE(STATUS.XANDR_SEGMENTATION_CAMPAIGN_CREATE, 'Xandr Campaign Created'),
      RECEIVE_TARGET_LIST_FILE: CE(STATUS.RECEIVE_TARGET_LIST_FILE, 'Xandr Target List File Received'),
      XANDR_DATA_CREATE_CAMPAIGN: CE(STATUS.XANDR_DATA_CREATE_CAMPAIGN, 'Xandr Data Campaign Created'),
      RECEIVE_PLANNING_FILE: CE(STATUS.RECEIVE_PLANNING_FILE, 'Received Planning File'),
      RECEIVE_XANDR_DATA_UPDATE: CE(STATUS.RECEIVE_XANDR_DATA_UPDATE, 'Received Xandr Data Update'),
      MAKE_XANDR_DATA_UPDATE: CE(STATUS.MAKE_XANDR_DATA_UPDATE, 'Made Update to Xandr Data'),
      CAE_CCPID: CE(STATUS.CAE_CCPID, 'CAE CCPID Received'),
    }
    return {
      selectedButton: 1,
      selectedTarget: '',
      selectedDate: moment().add(-30, 'days').toDate(),
      todaysDate: new Date(),
      columnDef: COLUMN_DEF,
      traces: [],
      /**
       * {
       *  eventId: [event, event, ...],
       *  eventId2: [event, event, ....],
       *  ...
       * }
       */
      events: {},
      /**
       * {
       *  Id: [event, event, event....],
       *  id2: [evnet,....],
       *  ....
       * }
       */
      ids: {},
      /**
       * this will contian the highest rated event in the HEIRARCHY_EVENTS for each of the ids
       * {
       *  eventId: [event, event, .....],
       *  eventId2: [event, ......],
       *  .....
       * }
       */
      heirarchyData: {},
      /**
       * sparce data is any data point that could occur given an action
       * [
       *  {
       *    eventId: [event, event2, ...],
       *    ....
       *  },
       *  {
       *    eventId: [event, event2, ...],
       *    ....
       *  }
       * ]
       */
      sparceData: [],
      eventTypes: EVENTS
    }
  },
  mounted () {
    this.getTopEvents()
  },
  methods: {
    getTopEvents () {
      XandrAPI.getTopLevelTracing(this.selectedDate).then(data => {
        this.setEvents(data)
      })
    },
    getAllEvents () {
      XandrAPI.getXandrTracing(this.selectedDate).then(data => {
        this.setEvents(data)
      })
    },
    getEventsOfSelectedTarget () {
      XandrAPI.getXandrTracing(this.selectedDate, this.selectedTarget).then(data => {
        this.setEvents(data)
      })
    },
    setUpEventTypes () {
      // this.eventTypes
    },
    setEvents (data) {
      this.events = {}
      for (let e of data) {
        if (!this.events[e.event]) {
          this.events[e.event] = []
        }
        e.daysSinceEvent = moment().add(10, 'days').diff(moment(e.date), 'days')
        this.events[e.event].push(e)
      }
      this.ids = {}
      for (let e of data) {
        if (!this.ids[e.id]) {
          this.ids[e.id] = []
        }
        this.ids[e.id].push(e)
      }
      // sort the events in descending order
      for (let i of Object.keys(this.ids)) {
        this.ids[i] = this.ids[i].sort((a, b) => {
          return b.event - a.event
        })
      }

      // set the heirarchyData to a empty list
      for (let eId of Array.from(HEIRARCHY_EVENTS)) {
        this.heirarchyData[eId] = []
      }
      // now add the highest event id for each ID that's envent id is in heirarchyData
      for (let i of Object.keys(this.ids)) {
        let eventsOfId = this.ids[i]
        for (let e of eventsOfId) {
          if (HEIRARCHY_EVENTS.has(e.event)) {
            this.heirarchyData[e.event].push(e)
            break
          }
        }
      }
      // have to set up the sparceData object
      this.sparceData = []
      for (let lOfEvent of SPARCE_EVENTS) {
        let sparceEvents = {}
        this.sparceData = sparceEvents
        for (let e of lOfEvent) {
          sparceEvents[e] = this.events[e]
        }
      }
      this.heirarchyData = {...this.heirarchyData}
      this.events = {...this.events}
    },
    setButtonTopLevel () {
      this.selectedButton = BUTTON_STATUS.TOP_LEVEL
      this.getTopEvents()
    },
    setButtonAllEvents () {
      this.selectedButton = BUTTON_STATUS.ALL_EVENTS
      this.getAllEvents()
    },
    setButtonOneTarget () {
      this.selectedButton = BUTTON_STATUS.ONE_TARGET
      this.getEventsOfSelectedTarget()
    }
  },
  computed: {
    getHeirarchyTopList () {
      return this.heirarchyData[20]
    },
    hasSelectedTarget () {
      return this.selectedTarget !== ''
    },
    buttonSelectedTopLevel () {
      return this.selectedButton === BUTTON_STATUS.TOP_LEVEL
    },
    buttonSelectedAllEvents () {
      return this.selectedButton === BUTTON_STATUS.ALL_EVENTS
    },
    buttonSelectedOneTarget () {
      return this.selectedButton === BUTTON_STATUS.ONE_TARGET
    }
  },
  watch: {
    heirarchyData () {
      console.log(this.heirarchyData)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// devPage.vue?666300c7